import { createContext, useContext, FC, useState } from "react";

const ProgressContext = createContext(null);

export const ProgressProvider: FC = ({ children }) => {
  const [ progress, setProgress ] = useState<number>(0);

  return <ProgressContext.Provider value={{progress, setProgress}}>{children}</ProgressContext.Provider>
};

export const useProgressContext = () => useContext(ProgressContext);
